module.exports = __webpack_public_path__ + "static/media/arrow-dark.74c7490e.svg";